import React from "react";
import classes from "./Services.module.css";

const Acupuncture = () => {
  return (
    <div className={classes.Intro}>
      {/**
       * The Header
       */}
      <h1 className={classes.focusLine}>
        <span>Acupuncture</span>
      </h1>
      {/**
       * The Header
       */}
      <div className={classes.container1}>
        <h4>
          WHAT IS FUNCTIONAL INTEGRATED NEEDLING AND WHAT ARE THE BENEFITS?
        </h4>
        <p>
          The FIN approach integrates a variety of dry needling techniques
          during a single session. Unlike acupuncture which traditionally
          selects points along meridians, dry needling targets anatomical
          structures that are the underlying cause of musculoskeletal
          conditions. The benefits are decreased pain, decreased muscle tension,
          and improved function.
        </p>
        {/**
         * The Header
         */}
        <h4>WHAT IS INVOLVED?</h4>
        <p>
          During a typical FIN treatment, thin filament needles are inserted
          into various targets that have been determined to be the underlying
          cause of the painful condition. They are left in from several seconds
          to 20 minutes. Typically there will be 10 or more needles used for
          most conditions. Different strategies are used for acute injuries and
          chronic pain conditions that make this a highly effective treatment
          modality for soft tissue injuries.
        </p>
        {/**
         * The Header
         */}
        <h4>HOW DOES IT WORK AND WHY IS IT SO EFFECTIVE?</h4>
        <p>
          The insertion of needles into the tissues causes the release of
          substances that help improve blood flow to areas of tightness and
          decreases sensitivity by neuromodulating the nervous system. These
          effects help control pain, improve function and speed up healing.
        </p>
        <p>
          The most widespread application of acupuncture is for{" "}
          <strong>pain relief</strong> , most commonly musculoskeletal pain and
          chronic pain. There is moderate to strong evidence to suggest that
          acupuncture is more effective than doing nothing for many conditions,
          and has an effect large enough to be clinically useful.
        </p>
        <p>This includes treatment for:</p>
        <ul>
          <li>chronic neck and low back pain</li>
          <li>
            upper extremity pain (including rotator cuff tendinitis, tennis
            elbow (“lateral epicondylitis”) )
          </li>
          <li>
            lower extremity pain, mainly due to osteoarthritis (chronic knee and
            hip pain)
          </li>
          <li>myofascial trigger point pain</li>
          <li>migraines and tension-type headaches</li>
        </ul>
      </div>
    </div>
  );
};

export default Acupuncture;
